import React from 'react';
import { Form, Input, Button,Modal } from 'antd';
import {LayoutData} from "../Structur/Aconlayout";
import { useState ,useEffect,useRef} from "react";
import { useNavigate } from "react-router-dom";

export const Anfrage = () => {
  // Funktion, die aufgerufen wird, wenn das Formular abgeschickt wird
  const {doPostEmail}=LayoutData();
  const handleSubmit = async (values) => {
    // Hier können Sie die Werte des Formulars verarbeiten, z.B. eine E-Mail senden
    console.log('Formular abgeschickt:', values);
    let status = await doPostEmail(values.name,values.email,values.message);
    console.log("status",status);
  };

  return (
    <Form layout="vertical" onFinish={handleSubmit}>
      <Form.Item
        label="Name"
        name="name"
        rules={[{ required: true, message: 'Bitte geben Sie Ihren Namen ein!' }]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        label="E-Mail"
        name="email"
        rules={[{ required: true, message: 'Bitte geben Sie Ihre E-Mail-Adresse ein!' }]}
      >
        <Input type="email" />
      </Form.Item>

      <Form.Item
        label="Nachricht"
        name="message"
        rules={[{ required: true, message: 'Bitte geben Sie Ihre Nachricht ein!' }]}
      >
        <Input.TextArea rows={4} />
      </Form.Item>

      <Form.Item>
        <Button type="primary" htmlType="submit">
          Senden
        </Button>
      </Form.Item>
    </Form>
  );
};


export const AnfrageModal = () => {
    const [modal2Open, setModal2Open] = useState(true);
    const navigate = useNavigate();
    return (
      <>
        <Modal
          title="Senden Sie uns eine Anfrage"
          width={400}
          centered
          open={modal2Open}
          cancelText="Schließen"
          onCancel={() => {
            setModal2Open(false);
            navigate("/");
          }}
          onOk={() => setModal2Open(false)}
          okText="-"
          okButtonProps={{style: { display: 'none' } }} 
          cancelButtonProps={{style:{display:'none'}}}
        >
          <Anfrage isModal={true} />
        </Modal>
      </>



    );
  };

